import {api} from "../../services";
import Swal from "sweetalert2";
import Vue from 'vue';
const leads = {
  state: {
    is_loading: false,
    pagination: [],
    data: [],
    lead: {
      address: {}
    },
    infos: {
      total: {},
      invalid: {},
      valid: {},
      verification: {},
    },
    search_lead: {
      name: "",
      phone: "",
      email: "",
      office: "",
      company: "",
      status_key: null,
      channel_id: null,
      start_date: null,
      final_date: null,
      newsletter_key: null,
      tags_id: [],
      custom_fields: [],
      custom_fields_values: [],
    },
    import_leads: {
      step: null,
    },
    reports: {
      channel_id: null,
      engagement_in: [],
      engagement_out: [],
      graph: {
        engagement_in: {
          values: [],
          series: [],
        },
        engagement_out: {
          values: [],
          series: [],
        },
      }
    },
    watch: 0,
    filter_leads_active: false
  },
  getters: {
    getLeadObject: (state) => (key, value) => {
      const object = state.data.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getLeadsArray: (state) => (key, value) => {
      if (state.data !== undefined) {
        return state.data.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
  },
  mutations: {
    SET_LOADING_LEADS(state, status) {
      state.is_loading = status;
    },
    SET_LEADS(state, payload) {
      state.pagination = payload
    },
    SET_LEADS_DATA(state, leads) {
      leads.forEach(lead => {
        const exist = state.data.find(e => {
          return e.id == lead.id;
        });
        if (!exist) {
          if (lead.address === null) {
            lead.address = {}
          }
          state.data.push(lead);
        }
      });
    },
    REMOVE_LEAD(state, leadId) {
      const filteredData = state.pagination.data.filter(lead => lead.id !== leadId);
      const filteredAll = state.data.filter(lead => lead.id !== leadId);
      Vue.set(state.pagination, 'data', filteredData);
      Vue.set(state, 'data', filteredAll);
      state.watch = Math.random();
      Vue.set(state, 'pagination', JSON.parse(JSON.stringify(state.pagination)));
      state.watch = Math.random();


    },

    SET_LEAD(state, payload) {
      state.lead = payload
    },
    SET_LEAD_INFOS(state, payload) {
      state.infos = payload
    },
    SET_IMPORT_LEADS(state, payload) {
      state.import_leads = payload
    },
    SET_REPORTS_LEADS_ENGAGEMENT_IN(state, payload) {
      state.reports.engagement_in = payload
    },
    SET_REPORTS_LEADS_ENGAGEMENT_OUT(state, payload) {
      state.reports.engagement_out = payload
    },
    SET_REPORTS_LEADS_ENGAGEMENT_IN_GRAPH(state, payload) {
      state.reports.graph.engagement_in = payload
      state.watch = Math.random()
    },
    SET_REPORTS_LEADS_ENGAGEMENT_OUT_GRAPH(state, payload) {
      state.reports.graph.engagement_out = payload
      state.watch = Math.random()
    },
  },
  actions: {
    setLeadsLoading({ commit }, status) {
      commit('SET_LOADING_LEADS', status);
    },
    async getFilterLeads({ commit }, payload = {}) {
      commit('SET_LOADING_LEADS', true)           
      try {
        const { data } = await api.get('/leads', { params: payload })
        commit('SET_LEADS', data)
        commit('SET_LEADS_DATA', data.data)
      } finally {
        commit('SET_LOADING_LEADS', false)       
      }
      },
      getLeadDetails(context, payload) {
        return new Promise((resolve, reject) => { // Garanta o retorno da Promise
          api.get(`/leads/${payload.id}`)
            .then(response => {
              if (response.data.address === null) response.data.address = {};
              context.commit("SET_LEAD", response.data);
              context.commit("SET_LEADS_DATA", [response.data]);
              resolve(response.data); // Resolva com os dados
            })
            .catch(error => {
              if (error.response.status === 401) this.dispatch('logoutUser');
              reject(error);
            });
        });
      },
  getLeads(context, payload = {}) {
    context.commit('SET_LOADING_LEADS', true);
    
    // Set a reasonable page size
    const params = { ...payload, per_page: 20 };
    
    return api.get('/leads', { params })
        .then(response => {
            context.commit("SET_LEADS", response.data);
            context.commit("SET_LEADS_DATA", response.data.data);
            context.commit('SET_LOADING_LEADS', false);
            return response.data;
        })
        .catch(error => {
            context.commit('SET_LOADING_LEADS', false);
            if (error.response && error.response.status === 401) {
                context.dispatch('logoutUser');
            }
            throw error;
        });
},
    getLead(context, payload) {
      api.get(`/leads/${payload.id}`).then(response => {
        if (response.data.address === null) {
          response.data.address = {}
        }
        context.commit("SET_LEAD", response.data);
        context.commit("SET_LEADS_DATA", [response.data]);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getLeadRedirect(context, payload) {
      api.get(`/leads/${payload}`).then(response => {
        if (response.data.address === null) {
          response.data.address = {}
        }
        context.commit("SET_LEAD", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    getLeadsData(context, payload) {
      if (payload !== undefined) {
        let ids = [];
        payload.forEach(item => {
          ids.push(item.lead_id);
          // const leads = context.state.data.find(lead => {
          //   return item.lead_id != lead.id
          // });
          // if (leads === undefined) {
          //   ids.push(item.lead_id);
          // }
        });
        if (ids.length > 0) {
          let lead_exists = false;
          if (ids.length == 1) {
            const lead_key = context.state.data.findIndex(lead => lead.id == ids[0] );

            if(lead_key >= 0) {
              const lead_name = context.state.data[lead_key] && context.state.data[lead_key].name
                ? context.state.data[lead_key].name
                : null;
              if (lead_name != null) {
                lead_exists = true;
              }
            }
          }
          if (!lead_exists) {
            api.post(`/leads/data`, {ids}).then(response => {
              context.commit("SET_LEADS_DATA", response.data);
            }).catch(error => {
              if (error.response.status === 401) {
                this.dispatch('logoutUser');
              }
            });
          }
        }
      }
    },
    updateLead(context, payload) {
      api.put(`/leads/${payload.id}`, payload).then((response) => {
        // this.dispatch('getLeads', payload.data);
        if (window.route.name === 'Lead') {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: context.rootGetters.getTranslations('expression_933'),
            showConfirmButton: false,
            timer: 1500
          })
          context.commit("SET_LEAD", response.data);
        }
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
  
    
    deleteLead(context, payload) {
      return api.delete(`/leads/${payload.id}`, payload)
        .then(() => {
          context.commit('REMOVE_LEAD', payload.id);
          const currentParams = { ...context.state.search_lead };
          return context.dispatch('getFilterLeads', currentParams);
        })
        .then( () => {
          Swal.fire({
            title: context.rootGetters.getTranslations('expression_1158'),
            allowOutsideClick: false, 
            allowEscapeKey: false, 
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2000,
            icon: 'success',
            toast: true,
            position: 'bottom-end',
          });
        })
        
        .catch(async (error) => {
          context.commit('SET_LOADING_LEADS', false);
          if (error.response && error.response.status === 401) {
            this.dispatch('logoutUser');
          } else {
            await Swal.fire(
              context.rootGetters.getTranslations('expression_406'),
              error.response?.data?.message || 'Erro ao deletar lead.',
              'warning'
            );
          }
        });
    },
    // Cards Info
    getLeadsInfo(context, payload = {}) {
      api.get('/leads/info', {
        params: payload
      }).then(response => {
        context.commit("SET_LEAD_INFOS", response.data);

      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    // Export Leads
    exportLeads(context, payload = {}) {
      api.post('/leads/download/excel', payload).then(() => {
        Swal.fire({
          position: 'center',
          icon: 'info',
          title: context.rootGetters.getTranslations('expression_934'),
          text: context.rootGetters.getTranslations('expression_935'),
          showConfirmButton: true,
        })
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    checkUploadLeads(context) {
      api.get(`/leads/upload`).then(response => {
        context.commit("SET_IMPORT_LEADS", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    deleteUploadErrorLeads(context) {
      api.delete(`/leads/upload`).then(() => {
        this.dispatch('checkUploadLeads')
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },

    deleteUploadAllLeads(context) {
      api.delete(`/leads/upload/all`).then(() => {
        context.commit("SET_IMPORT_LEADS", {
          step: 1
        });
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    confirmUploadLeads(context, payload) {
      api.post(`/leads/upload/confirm`, payload).then(response => {
        context.commit("SET_IMPORT_LEADS", {
          step: 5,
          channel_id: null,
          tags_id: []
        });
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    // Reports Engagement In
    getLeadsReportsEngagementIn(context, payload) {
      api.get('/leads/engagement/in', {
        params: payload
      }).then(response => {
        context.commit("SET_REPORTS_LEADS_ENGAGEMENT_IN", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    // Reports Engagement Out
    getLeadsReportsEngagementOut(context, payload = {}) {
      api.get('/leads/engagement/out', {
        params: payload
      }).then(response => {
        context.commit("SET_REPORTS_LEADS_ENGAGEMENT_OUT", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    // Graph In
    getLeadsReportsEngagementInGraph(context, payload = {}) {
      api.get('/leads/engagement/chart/in', {
        params: payload
      }).then(response => {
        context.commit("SET_REPORTS_LEADS_ENGAGEMENT_IN_GRAPH", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    // Graph Out
    getLeadsReportsEngagementOutGraph(context, payload = {}) {
      api.get('/leads/engagement/chart/out', {
        params: payload
      }).then(response => {
        context.commit("SET_REPORTS_LEADS_ENGAGEMENT_OUT_GRAPH", response.data);
        this.dispatch('stopLoading');
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
  },
}
export default leads;
